export default __webpack_public_path__ + "static/large-datasets-eb14575d01179a3e6de5aa47feac94d2.png";